import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ruiseki-table" }
const _hoisted_2 = { class: "a time" }
const _hoisted_3 = { class: "b time" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "c time"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "d time"
}

import { PropType } from 'vue'
import { format } from '@/lib/formatter'
import { RainRuiHistoryItem } from '@/models/RainRuiHistory'
import { useGlobalStore } from '@/stores/globalStore'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Array as PropType<RainRuiHistoryItem[]>,
    default: () => [],
  },
},
  setup(__props) {



const globalStore = useGlobalStore()

const formatTime = (startTime: string) => {
  return format(startTime, 'YYYY年MM月DD日 HH:mm')
}

const formatEndTime = (startTime: string, finished: boolean) => {
  return finished ? format(startTime, 'YYYY年MM月DD日 HH:mm') : ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (row, index) => {
      return (_openBlock(), _createElementBlock("tr", { key: index }, [
        _createElementVNode("td", _hoisted_2, _toDisplayString(formatTime(row.startTime)), 1),
        _createElementVNode("td", _hoisted_3, _toDisplayString(formatEndTime(row.endTime, row.finished)), 1),
        (!_unref(globalStore).isIchinomiya)
          ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(row.maxMoveRainMin10?.toFixed(1)), 1))
          : _createCommentVNode("", true),
        (!_unref(globalStore).isIchinomiya)
          ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_unref(format)(row.maxMoveRainMin10Time, 'YYYY年MM月DD日 HH:mm')), 1))
          : _createCommentVNode("", true),
        (!_unref(globalStore).isIchinomiya)
          ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(row.maxMoveRainMin60?.toFixed(1)), 1))
          : _createCommentVNode("", true),
        (!_unref(globalStore).isIchinomiya)
          ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_unref(format)(row.maxMoveRainMin60Time, 'YYYY年MM月DD日 HH:mm')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("td", null, _toDisplayString(row.rainRui?.toFixed(1)), 1)
      ]))
    }), 128))
  ]))
}
}

})